<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学导跟进数据</Breadcrumb-item>
        <Breadcrumb-item>学导申请加课时记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生姓名" :label-width="75">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.userNickname"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookCourseChange/listAddCourseDetail"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
  import StudentInfo from '../common/StudentInfo.vue'
  export default {
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        queryParam: {
          studyAdviserId: '',
          uid: '',
          userNickname: '',
          adminNickname: '',
          startTimeSec: '',
          endTimeSec: '',
        },
        title: [
          {
            title: '学生姓名',
            render: (h, params) => {
              let row = params.row
              return h(StudentInfo, {
                props: {
                  name: `${row.userNickname || ''}`,
                  uid: row.uid
                }
              })
            }
          },
          {
            title: '课程类别',
            align: 'center',
            width: 85,
            render: (h, params) => {
              let courseType = params.row.courseType
              let typeEnum = $constant.getEnum($constant.courseType, courseType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '加课时数量',
            align: 'right',
            key: 'num',
          },
          {
            title: '申请人',
            key: 'adminNickname'
          },
          {
            title: '申请时间',
            align: 'center',
            width: 135,
            render: (h, params) => {
              let createTime = params.row.createTime
              return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '备注',
            // ellipsis: true,
            key: 'reason'
          },
          {
            title: '状态',
            width: 72,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '审核人',
            key: 'checkAdmin'
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.studyAdviserId = localStorage.studyAdviserId
      this.queryParam.startTimeSec = localStorage.startTime
      this.queryParam.endTimeSec = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }

</script>



// WEBPACK FOOTER //
// ShowAddCourseDetail.vue?cbd8d396